import {TwitterController} from "./recursos/twitter";
import {TwitchController} from "./recursos/twitch";
import {YoutubeController} from "./recursos/youtube";
import {BesoccerController} from "./recursos/besoccer";
import {DailymotionController} from "./recursos/dailymotion";
import {TiktokController} from "./recursos/tiktok";
import {InstagramController} from "./recursos/instagram";
import {NativosController} from "./recursos/nativos";
import {EstadioController} from "./recursos/estadio";
import {DailymotionControllerVideoNoticia} from "./recursos/dailymotion-video-noticia";
import {DailymotionControllerVideoSeccion} from "./recursos/dailymotion-video-seccion";
import {PublicidadController} from "./publicidad";

declare global {
    interface Window {
        __tcfapiprivate: any;
        scheduler: any;
        _comscore: any;
    }
}

export class CmpController {

    /* INSTANCE */
    public static instance: CmpController;

    /* STATIC */
    public static async build(): Promise<void> {
        CmpController.instance = new this();
    }

    private constructor() {
        window.__tcfapiprivate('addEventListener', 'cmpReady', function () {
            window.__tcfapiprivate('addEventListener', 'isConfigured', function (consent: any) {
                window.cmp_value = "" + consent.acceptanceLevel;
                CmpController.loadComscore();
                if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') {
                    window.scheduler.postTask(()=>{ PublicidadController.build(); }, {priority: "user-blocking"});
                    if (window.tipologia === "noticia") {
                        window.scheduler.postTask(()=>{ TwitterController.build() }, {priority: "background"});
                        window.scheduler.postTask(()=> { TwitchController.build() }, {priority: "background"});
                        window.scheduler.postTask(()=>{ TiktokController.build() }, {priority: "background"});
                        window.scheduler.postTask(()=> { YoutubeController.build() }, {priority: "background"});
                        window.scheduler.postTask(() =>{ BesoccerController.build() }, {priority: "background"});
                        window.scheduler.postTask(()=>{ DailymotionController.build() }, {priority: "background"});
                        window.scheduler.postTask(()=>{ InstagramController.build() }, {priority: "background"});
                        window.scheduler.postTask(()=>{ EstadioController.build() }, {priority: "background"});
                    }
                    if (window.tipologia === "video") {
                        if (window.subtipologia === "noticia") {
                            window.scheduler.postTask(()=>{ DailymotionControllerVideoNoticia.build() }, {priority: "background"});
                        } else {
                            window.scheduler.postTask(()=>{ DailymotionControllerVideoSeccion.build() }, {priority: "background"});
                        }
                    }
                    window.scheduler.postTask(()=>{ NativosController.build() }, {priority: "background"});
                    window.scheduler.postTask(()=>{ PublicidadController.loadAdBlockingRecovery() }, {priority: "background"});
                } else {
                    PublicidadController.build();
                    if (window.tipologia === "noticia") {
                        TwitterController.build()
                        TwitchController.build();
                        TiktokController.build();
                        YoutubeController.build();
                        BesoccerController.build();
                        DailymotionController.build();
                        InstagramController.build();
                        EstadioController.build();
                    }
                    if (window.tipologia === "video") {
                        if (window.subtipologia === "noticia") {
                            DailymotionControllerVideoNoticia.build();
                        } else {
                            DailymotionControllerVideoSeccion.build();
                        }
                    }
                    NativosController.build();
                    PublicidadController.loadAdBlockingRecovery();
                }
            });
        });
    }

    private static loadComscore(): void {
        window._comscore = window._comscore || [];
        window._comscore.push({
            c1: "2",
            c2: "14673720",
            options: {
                enableFirstPartyCookie: true,
                bypassUserConsentRequirementFor1PCookie: true,
            }
        });
        const script = document.createElement('script');
        script.src = 'https://sb.scorecardresearch.com/cs/14673720/beacon.js';
        script.async = true;
        document.head.appendChild(script);
    }

}
